import React, { useEffect, useRef } from 'react';

import { mount } from 'redom';

import NativeExpandableEditorActionButton from './';

function NativeExpandableEditorActionButtonReactWrapper(props) {

  const wrapperMainReference = useRef(null);
  const nativeExpandableEditorActionButtonReference = useRef(null);

  useEffect(function onLoad() {

    const nativeExpandableEditorActionButton = new NativeExpandableEditorActionButton(props);

    nativeExpandableEditorActionButtonReference.current = nativeExpandableEditorActionButton;

    mount(wrapperMainReference.current, nativeExpandableEditorActionButtonReference.current);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(function onPropsChange() {

    nativeExpandableEditorActionButtonReference.current.update(props);

  }, [props]);

  function renderMain() {

    const mainAttributes = {
      className: 'expandable-editor-button-native-react-wrapper-main',
      ref: wrapperMainReference
    };

    return <div {...mainAttributes}>
    
    </div>;

  }

  return renderMain();

}

export default NativeExpandableEditorActionButtonReactWrapper;